var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('egranty-section-divider',{attrs:{"small":true,"text":"Angielska nazwa projektu"}}),_c('v-card-text',[_c('display-text-component',{attrs:{"label":"Nazwa","value":_vm.value,"flex":"full-width"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }